import { QuestionModule } from '@/enums';

// 後台顯示用的中文名稱；資料庫內的代號維持不變，未對應到的名稱直接顯示原值
const moduleLabels: Record<string, string> = {
  [QuestionModule.Common]: '基本資料',
  [QuestionModule.Business]: '業務範疇',
  [QuestionModule.SDGs]: 'SDGs 評估',
};

const answerOptionSetLabels: Record<string, string> = {
  operationYears: '經營年限',
  sdgsScore: 'SDGs 評分（0–5 分）',
};

export const getModuleLabel = (name: string): string =>
  moduleLabels[name.toLowerCase()] ?? name;

export const getAnswerOptionSetLabel = (name: string): string =>
  answerOptionSetLabels[name] ?? name;
